import { Modal, Button } from "antd";
import { LeftOutlined } from "@ant-design/icons";
import sinCobertura from "../assets/images/sin-cobertura2.png";
import "./ModalSinCobertura.css";

const ModalSinCobertura = ({ open, onClose, title }) => {
  return (
    <Modal
      open={open}
      onCancel={onClose}
      centered
      className="modal-sin-cobertura"
      style={{ backgroundColor: "#FFF2F0", borderRadius: "25px" }}
      footer={
        <div style={{ textAlign: "center", width: "100%" }}>
          <Button
            key="ok"
            type="primary"
            onClick={onClose}
            icon={<LeftOutlined />}
            style={{
              backgroundColor: "#EA4E2F",
              borderRadius: "25px",
              fontWeight: 600,
              width: "80%",
              height: "50px",
              textAlign: "center",
              fontFamily: "Manrope",
            }}
          >
            Volver
          </Button>
        </div>
      }
    >
      <div
        style={{
          textAlign: "center",
          fontFamily: "Manrope",
          width: "100%"
        }}
      >
        <img
          src={sinCobertura}
          alt="Sin cobertura"
          style={{ 
            width: "100%", 
            display: "block",
            marginBottom: 0 
          }}
        />

        <div style={{ padding: "0px" }}>
          <h2
            style={{ marginBottom: 0, color: "#021442", fontFamily: "Manrope" }}
          >
            {title}
          </h2>

          <p
            style={{
              color: "#021442",
              textAlign: "center",
              fontFamily: "Manrope",
            }}
          >
            En este momento <strong>no contamos con cobertura</strong> en tu zona, pero estamos trabajando para pronto prestar nuestros servicios dónde estás.
          </p>
        </div>
      </div>
    </Modal>
  );
};

export default ModalSinCobertura;